import { Product } from '../product.model'

export function checkProductKitsValid(product: Product): boolean {
  if (product.productType !== 'KIT') {
    return true
  }

  return !!product.kitProducts?.length
}
